<div class="container-fluid complyon-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell mx-auto">
    <div class="mb-3">
      <h1 class="complyon-title mb-2 text-l">Master data</h1>
      <p class="complyon-subtitle mb-0 text-s">The controlled lists every module draws from - categories, types and codes that keep dashboards and reports consistent.</p>
    </div>

    <div class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <div class="complyon-card rounded-4 p-3 h-100">
          <div class="text-uppercase text-xs text-secondary fw-semibold">{{ card.label }}</div>
          <div class="text-l fw-bold mt-1">{{ card.value }}</div>
          <div class="text-xs text-secondary mt-3">{{ card.note }}</div>
        </div>
      </div>
    </div>

    <div class="complyon-panel rounded-4 overflow-hidden">
      <div class="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
        <div class="complyon-section-title text-s">Master data</div>
        <div class="complyon-section-subtitle text-xs">The controlled lists every module draws from. A value here is not just a label - it can trigger rules downstream. Open a list to see what each value drives.</div>
      </div>

      <div class="px-3 px-md-4 py-3 py-md-4">
        <div class="row g-3">
          <div v-for="item in categories" :key="item.title" class="col-12 col-md-6 col-xl-4">
            <div class="complyon-card rounded-4 p-3 h-100 d-flex align-items-center justify-content-between gap-3">
              <div class="d-flex align-items-start gap-3 min-w-0">
                <div class="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 bg-info-subtle text-info-emphasis" style="width: 2rem; height: 2rem;">
                  <i class="bi" :class="item.icon"></i>
                </div>
                <div class="min-w-0">
                  <div class="fw-semibold text-s">{{ item.title }}</div>
                  <div class="text-xs text-secondary">{{ item.meta }}</div>
                </div>
              </div>
              <i class="bi bi-chevron-right text-secondary"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
